'use client';

import {
  faFaceExplode,
  faGem,
  faHandsClapping,
  faHeart,
  faThumbsUp,
} from '@fortawesome/pro-solid-svg-icons';

import { ProgressCircle } from '.';
import { Icon, type IconDefinition } from '../Icon/Icon';
import { cn } from '../utils/cn';

export type Reaction = 'love' | 'applaud' | 'like' | 'gem' | 'astonished';

export type ReactionMapType = {
  [key in Reaction]: {
    color: string;
    bgColor: string;
    icon: IconDefinition;
  };
};

export const reactionMap: ReactionMapType = {
  love: {
    color: 'text-pink-400',
    bgColor: '#ec4899',
    icon: faHeart,
  },
  applaud: {
    color: 'text-indigo-500',
    bgColor: '#6366f1',
    icon: faHandsClapping,
  },
  like: {
    color: 'text-green-400',
    bgColor: '#34d399',
    icon: faThumbsUp,
  },
  gem: {
    color: 'text-orange-400',
    bgColor: '#f97316',
    icon: faGem,
  },
  astonished: {
    color: 'text-sky-400',
    bgColor: '#38bdf8',
    icon: faFaceExplode,
  },
};

export const getReactionStyles = (
  reaction: Reaction,
): { color: string; bgColor: string; icon: IconDefinition } => {
  if (!Object.prototype.hasOwnProperty.call(reactionMap, reaction)) {
    return { bgColor: '', color: '', icon: faHeart };
  }

  const { color, bgColor, icon } = reactionMap[reaction];

  return { color, bgColor, icon };
};

export const renderReaction: React.FC<Reaction> = (reaction: Reaction) => {
  const { color, bgColor, icon } = getReactionStyles(reaction);

  return (
    <div className='absolute right-[-15%] top-[65%] z-10 flex h-[18px] w-[18px] items-center justify-center rounded-full bg-white'>
      <ProgressCircle
        height={16}
        width={16}
        borderWidth={1}
        borderColor={bgColor}
        gradient={{ startColor: '#FFFFFF', endColor: bgColor }}
      >
        <Icon icon={icon} className={cn('size-2.5', color)} />
      </ProgressCircle>
    </div>
  );
};
